import React from 'react';
import { Divider } from '@mui/material';
import './SDivider.scss';

function SDivider() {
  return <Divider>Or</Divider>;
}

export { SDivider };
